import { useTranslation } from "react-i18next";

import PageView from "../../../ui/views/PageView/PageView";

import WhatsNewRelease from "./components/WhatsNewRelease";

export default function WhatsNewView({ releases }) {
	const { t } = useTranslation();

	return (
		<PageView maxWidth={800} header={t("whatsNew", "What's new")}>
			{releases.map((release, index) => (
				<WhatsNewRelease key={release.version} release={release} latest={index === 0} />
			))}
		</PageView>
	);
}
